import { Component, Input} from '@angular/core';
import { traceButton2 } from '../../../../../common/services/button-trace';

@Component({
    selector: 'app-immediate-management',
    templateUrl: './immediate-management.component.html',
    styleUrls: ['./immediate-management.component.scss']
})
export class ImmediateManagementComponent {
    @Input() showImages: boolean;
    public traceButton2 = traceButton2;

    list = [
        {
            icon: 'pencil',
            title: 'Firmar PDF',
            text: 'Aprende como vincular tu firma para firmar documentos PDF'
        }, {
            icon: 'googl',
            title: 'Cargar tu firma en el navegador',
            text: 'Carga tu firma a Google Chrome o Firefox desde Mac o Windows.'
        }, {
            icon: 'unlock',
            title: 'Recuperar tu contraseña',
            text: 'Si no recuerdas la contraseña de tu firma recupérala aquí.'
        }, {
            icon: 'paper-plane',
            title: 'Reenviar tu firma',
            text: 'Si no consigues el archivo de tu firma electrónica reenvíalo a tu correo.'
        }
    ]

    constructor() { }

}
